import { Box, styled } from '@mui/material'
import { ContentEditable } from '@lexical/react/LexicalContentEditable'
import { AttachmentPreview } from 'ComponentLibrary/src/molecules/TextEditor/AttachmentPreview'

type CustomTextInputProps = {
    newDocuments: File[]
    setNewDocuments: React.Dispatch<React.SetStateAction<File[]>>
}

export default function CustomTextInput({ newDocuments, setNewDocuments }: CustomTextInputProps) {
    return (
        <TextInputContainer>
            <StyledContentEditable />
            <AttachmentPreview
                label="Anhänge"
                documents={newDocuments.map((doc) => ({ url: URL.createObjectURL(doc), name: doc.name }))}
                removeDocument={(index: number) => setNewDocuments((prev) => prev.toSpliced(index, 1))}
            />
        </TextInputContainer>
    )
}

const TextInputContainer = styled(Box)`
    width: 100%;
    grid-row: 2;
    grid-column: 1;
    padding: 12px;
    max-height: calc(50vh - 50px);
    overflow-y: auto;
    border: 1px solid #ccc;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border-top: none;
    overflow-x: hidden;
`

const StyledContentEditable = styled(ContentEditable)`
    font-size: 16px;
    grid-column: 1;
    :focus-visible {
        outline: none;
    }
    & > p {
        margin: 0;
    }
`
